import React from "react";
import { Link } from "react-router-dom";
import ContactImg from "../../assets/graphics/contact.svg";
import HeroImg from "../../assets/graphics/hero.png";
import MRPImg from "../../assets/images/hero-imgs/mrp.png";
import SchedulerImg from "../../assets/images/hero-imgs/scheduler.png";
import AwareImg from "../../assets/images/hero-imgs/aware.png";
import WarehouseImg from "../../assets/images/hero-imgs/warehouse.png";
import QualityImg from "../../assets/images/hero-imgs/quality.png";
import AlpacaLogo from "../../assets/logos/AlpacaMSwhite.svg";
import BusinessCentralLogo from "../../assets/logos/business-central-white.png";
import ErpLogo1 from "../../assets/logos/erp-logos/1.png";
import ErpLogo2 from "../../assets/logos/erp-logos/2.png";
import ErpLogo3 from "../../assets/logos/erp-logos/3.png";
import ErpLogo4 from "../../assets/logos/erp-logos/4.png";
import ErpLogo5 from "../../assets/logos/erp-logos/5.png";

import "./homeHero.scss";

const HeroSection = () => {
  return (
    <div>
      <div className="newHeroContainer">
        <div className="gridContainer">
          <div className="columnLeft">
            <h1 className="mainHeadline white">Manufacturing simplicity</h1>
            <p className="body-text left white">
              Software solutions developed by manufacturers for manufacturers.
            </p>
            <div className="buttonContainer">
              <a href="#form">
                <button className="main-btn">Get a Demo</button>
              </a>
              <a href="#form">
                <button className="white-btn">Contact Us</button>
              </a>
            </div>
            <div className="hero-logos">
              <img
                src={AlpacaLogo}
                className="alpaca-ms-hero"
                alt="Alpaca MS Logo"
              />
              <img
                src={BusinessCentralLogo}
                className="bc-white"
                alt="Business Central Logo"
              />
            </div>
          </div>
          <div className="columnRight">
            <img src={HeroImg} alt="Hero Image" />
          </div>
        </div>
        <div className="appImgContainer">
          <img src={MRPImg} className="mrp" title="Lucid MRP" alt="Lucid MRP" />
          <img
            src={SchedulerImg}
            className="scheduler"
            title="Lucid Visual Scheduler"
            alt="Lucid Visual Scheduler"
          />
          <img
            src={AwareImg}
            className="quality"
            title="Lucid Aware"
            alt="Lucid Aware"
          />
          <img
            src={WarehouseImg}
            className="warehouse"
            title="Lucid Warehouse"
            alt="Lucid Warehouse"
          />
          <img
            src={QualityImg}
            className="aware"
            title="Lucid Quality"
            alt="Lucid Quality"
          />
        </div>
      </div>
      <div className="bottomLogos">
        <h5 className="smallSubhead">
          ERP systems available in the near future:
        </h5>
        <div className="logoContainer">
          <img src={ErpLogo1} className="erp-icon" alt="ERP Logo 1" />
          <img src={ErpLogo2} className="erp-icon" alt="ERP Logo 2" />
          <img src={ErpLogo3} className="erp-icon" alt="ERP Logo 3" />
          <img src={ErpLogo4} className="erp-icon" alt="ERP Logo 4" />
          <img src={ErpLogo5} className="erp-icon" alt="ERP Logo 5" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
